import type { RealityCheckState } from '@/types/reality-check';
import type { RootState, SetState } from '../store';

export type RealityCheckSliceProps = {
    realityCheck: RealityCheckState & {
        setRealityCheckData: (data: Partial<RealityCheckState>) => void;
        showModal: () => void;
        hideModal: () => void;
        reset: () => void;
    };
};

const initialState: RealityCheckState = {
    playedTime: 0,
    profitAndLoss: 0,
    interval: 0,
    currentTimer: 0,
    timer: 0,
    isModalVisible: false
};

export const realityCheckSlice = ({ set }: SetState<RootState>): RealityCheckSliceProps => ({
    realityCheck: {
        ...initialState,

        setRealityCheckData: (data: Partial<RealityCheckState>) =>
            set(
                (state) => ({
                    ...state,
                    realityCheck: {
                        ...state.realityCheck,
                        ...data
                    }
                }),
                false,
                'realityCheck/setData'
            ),

        showModal: () =>
            set(
                (state) => ({
                    ...state,
                    realityCheck: {
                        ...state.realityCheck,
                        isModalVisible: true
                    }
                }),
                false,
                'realityCheck/showModal'
            ),

        hideModal: () =>
            set(
                (state) => ({
                    ...state,
                    realityCheck: {
                        ...state.realityCheck,
                        isModalVisible: false
                    }
                }),
                false,
                'realityCheck/hideModal'
            ),

        reset: () =>
            set(
                (state) => ({
                    ...state,
                    realityCheck: {
                        ...initialState,
                        ...state.realityCheck
                    }
                }),
                false,
                'realityCheck/reset'
            )
    }
});
